import { Box } from "@mui/material";
import { useAIHighlight } from "utils/AIHighlightContext";
import { AI_SUGGESTIONS_CONFIG } from "utils/aiSuggestionsConfig";

const AIHighlightWrapper = ({ fieldKey, children }) => {
  const isHighlighted = useAIHighlight(fieldKey);

  return (
    <Box
      sx={
        isHighlighted
          ? {
              outline: `2px solid ${AI_SUGGESTIONS_CONFIG.HIGHLIGHT_COLOR}`,
              outlineOffset: "-2px",
              borderRadius: "4px",
              boxShadow: `0 0 8px ${AI_SUGGESTIONS_CONFIG.HIGHLIGHT_COLOR}80`,
              transition: "outline-color 0.2s ease, box-shadow 0.2s ease",
            }
          : { transition: "outline-color 0.2s ease, box-shadow 0.2s ease" }
      }
    >
      {children}
    </Box>
  );
};

export default AIHighlightWrapper;
